// extracted by mini-css-extract-plugin
export var container = "stats-module--container---iti2";
export var content = "stats-module--content--rU3et";
export var description = "stats-module--description--fnr8A";
export var item = "stats-module--item--Uvdws";
export var number = "stats-module--number--Y6mZv";
export var unit = "stats-module--unit--PGgNJ";